import React, { useState } from 'react';
import styles from './BrandManagement.module.scss';
import { Col, Container, Row, TabContent, TabPane } from 'reactstrap';
import BrandsFilterTabs from '../../../../components/SellerPortalComponents/BrandsFilterTabs/BrandsFilterTabs';
import BrandsInformation from '../../../../components/SellerPortalComponents/BrandManagementTabs/BrandsInformation/BrandsInformation';
import BrandDetail from '../../../../components/SellerPortalComponents/BrandManagementTabs/BrandsInformation/BrandDetail/BrandDetail';
import AddBrandInformation from '../../../../components/SellerPortalComponents/BrandManagementTabs/AddBrandInformation/AddBrandInformation';
import PerformanceInsight from '../../../../components/SellerPortalComponents/BrandManagementTabs/PerformanceInsight/PerformanceInsight';
import GuidelineSupport from '../../../../components/SellerPortalComponents/BrandManagementTabs/GuidelineSupport/GuidelineSupport';

const managementTabs = [
    { id: '1', label: 'Brands Information' },
    { id: '2', label: 'Add New Brand' },
    { id: '3', label: 'Performance Insights' },
    { id: '4', label: 'Guidelines and Support' },
];

const BrandManagement = () => {
    const [activeTab, setActiveTab] = useState('1');
    const [isBrandDetail, setIsBrandDetail] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [columnsData, setColumnsData] = useState([]);

    return (
        <div className={styles.mainBrandManagementContainer}>
            <Container fluid className={styles.brandManagementWrapper}>
                <Row className={styles.brandManagementRow}>
                    <Col xs="12">
                        <BrandsFilterTabs
                            tabs={managementTabs}
                            activeTab={activeTab}
                            setActiveTab={setActiveTab}
                        />
                    </Col>
                </Row>

                <Row className='g-0'>
                    <Col>
                        <TabContent activeTab={activeTab}>
                            <TabPane tabId='1'>
                                {activeTab === '1' && (
                                    isBrandDetail ?
                                        <BrandDetail
                                            setIsBrandDetail={setIsBrandDetail}
                                            selectedRow={selectedRow}
                                            columnsData={columnsData}
                                        />
                                        :
                                        <BrandsInformation
                                            setIsBrandDetail={setIsBrandDetail}
                                            setSelectedRow={setSelectedRow}
                                            columnsData={columnsData}
                                            setColumnsData={setColumnsData}
                                        />
                                )}
                            </TabPane>
                            <TabPane tabId='2'>
                                {activeTab === '2' && <AddBrandInformation />}
                            </TabPane>
                            <TabPane tabId='3'>
                                {activeTab === '3' && <PerformanceInsight />}
                            </TabPane>
                            <TabPane tabId='4'>
                                {activeTab === '4' && <GuidelineSupport />}
                            </TabPane>
                        </TabContent>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default BrandManagement;
